import { Tooltip } from "antd"
import React from "react"
import { Globe as GlobeIcon } from "react-feather"
import { useTranslation } from "react-i18next"
import { SettingsLayout } from "../settings.layout"
import { GetMyInvoicesSettings } from "./getMyInvoicesIntegration"

export const UserIntegrations = () => {
    const { t } = useTranslation()
    return (
        <SettingsLayout
            preTitle={
                <Tooltip title={t("tooltips:setting_scope.global")}>
                    <GlobeIcon className="mr-10" />
                </Tooltip>
            }
            titleKey="label:integrations"
        >
            <div className="flex flex-col w-full justify-items-center">
                <GetMyInvoicesSettings />
            </div>
        </SettingsLayout>
    )
}
